import { cn } from "~/lib/utils";

import { ScrollArea } from "../ui";

interface Props {
  children: React.ReactNode;
  className?: string;
  containerClassName?: string;
}
const ScrollablePageWrapper = ({
  children,
  className,
  containerClassName,
}: Props) => {
  return (
    <ScrollArea
      className={cn(
        "h-container-scroll-height w-full overflow-auto",
        containerClassName,
      )}
    >
      <div className={cn("pb-1", className)}>{children}</div>
    </ScrollArea>
  );
};

export default ScrollablePageWrapper;
